import React, { useState, useImperativeHandle, useContext, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import TContext from '../../context'
import PContext from '../context'
import Animate from '../../../animate'
import { Toast, Empty, Infiniteloading } from '@nutui/nutui-react';
import http, { uploadFile } from '../../../../lib/http'
import * as apis from '../../../../lib/apis'
import { cloneDeep } from 'lodash';
import UploadIcon from '../../../../static/img/upload_img.png'

interface Props {
    action?: any
}

export interface Action {
    setShow?: (isShow: boolean) => void;
    confirm?: () => boolean;
    cancel?: () => void;
    isPreviewPatternObjectExist?: () => boolean;
}

const groupHeight = 40
const titleHeight = 30
export const Height = groupHeight

var previewPatternObject: any = null

const Index = (props: Props) => {
    const [show, setInnerShow] = useState(false)
    const page = useRef(1)
    const categoryId = useRef(0)
    const [patternGroups, setPatternGroups] = useState<any>([])
    const [patternList, setPatternList] = useState({ list: [], total: 0 })
    const [currentPatternId, setCurrentPatternId] = useState(-1)
    const [curPatternGroupId, setCurPatternGroupId] = useState<number>(0)
    const tc = useContext(TContext)
    const pc = useContext(PContext)
    const uploadRef = useRef<any>()

    useImperativeHandle(props.action, () => ({
        setShow,
        confirm,
        cancel,
        isPreviewPatternObjectExist
    }));

    const loadPatternList = async () => {
        try {
            const patterns: any = await http.get(apis.DESIGNER_PATTERN
                , {
                    params: { page: page.current, limit: 15, status: 1, category_id: categoryId.current },
                }
            )
            if (page.current === 1) {
                setPatternList(patterns)
                return
            }
            setPatternList((pre: any) => {
                let cpList: any = cloneDeep(pre)
                cpList.total = patterns.total
                cpList.list = [...cpList.list, ...patterns.list]
                return cpList
            })
        } catch (error) {

        }
    }


    const setShow = async (isShow: boolean) => {
        previewPatternObject = null
        setInnerShow(isShow)
        if (isShow) {
            Toast.loading(t("加载中"), {
                cover: true, // 是否展示透明遮罩层
                // coverColor: 'rgba(0, 0, 0, 0)', // 遮罩颜色设定
                closeOnClickOverlay: false, // 点击遮罩可关闭
                duration: 0
            })
            page.current = 1
            try {
                const patternGroups: any = await http.get(apis.DESIGNER_PATTERN_CATEGORY
                    , {
                        params: {
                            page: page.current,
                            limit: 10,
                        }
                    }
                )
                patternGroups?.list?.unshift({ id: 0, name: "全部" })
                setPatternGroups(patternGroups?.list)
                await loadPatternList()
                setCurPatternGroupId(0)
            } catch (error) {

            }
            Toast.hide()
        }
    }

    const loadPattern = async (groupId: number) => {
        if (groupId === curPatternGroupId) {
            return
        }
        page.current = 1
        categoryId.current = groupId
        loadPatternList()
        setCurPatternGroupId(groupId)
    }

    //纹样预览
    const previewPattern = async (v: any) => {
        Toast.loading(t("图片加载中"), {
            cover: true, // 是否展示透明遮罩层
            // coverColor: 'rgba(0, 0, 0, 0)', // 遮罩颜色设定
            closeOnClickOverlay: false, // 点击遮罩可关闭
            duration: 0
        })
        try {
            setCurrentPatternId(v.id)
            if (previewPatternObject) {
                tc.curCanvasClient.getFabricCanvas().remove(previewPatternObject)
                previewPatternObject = null
            } else {
                // pc?.addStep!(null)
            }
            previewPatternObject = await tc.curCanvasClient.addImageById(v.path, tc.fabricW as number * 0.5)
            tc.curCanvasClient.getFabricCanvas().renderAll()
            Toast.hide()
        } catch (error) {
            Toast.fail(t("失败，请重试一下"))
        }
    }

    // //取消
    const cancel = () => {
        setInnerShow(false)
        setCurrentPatternId(-1)
    }
    // 确认当前的previewPatternObject是否存在
    const isPreviewPatternObjectExist = () => {
        return previewPatternObject !== null
    }

    //确认
    const confirm = () => {
        if (!previewPatternObject) {
            return false
        }
        setInnerShow(false)
        setCurrentPatternId(-1)
        tc.curCanvasClient.getFabricCanvas().setActiveObject(previewPatternObject)
        tc.curCanvasClient.getFabricCanvas().renderAll()
        return true
    }

    //加载更多
    const onLoadMore = async (done: () => void) => {
        page.current++
        try {
            await loadPatternList()
        } catch (error) {
            page.current--
        }
        done()
    }

    //上传
    const fileOnChange = async (e: any) => {
        const input = e.target
        if (input.files && input.files.length !== 0) {
            Toast.loading(t("上传中"), {
                cover: true, // 是否展示透明遮罩层
                // coverColor: 'rgba(0, 0, 0, 0)', // 遮罩颜色设定
                closeOnClickOverlay: false, // 点击遮罩可关闭
                duration: 0
            })
            const file = input.files[0]
            try {
                const ossData: any = await uploadFile(apis.UPLOAD_IMAGE, file)
                Toast.hide()
                if (!ossData.data.url) {
                    Toast.fail(t("资源文件上传失败"))
                    return
                }
                previewPattern({ path: ossData.data.url })
                input.value = ''
            } catch (error) {
                Toast.fail(t("资源文件上传失败"))
            }
        }
    }


    return (

        <Animate show={show} style={{
            // display: show ? 'block' : 'none',
            bottom: 0,
            position: "fixed",
            left: 0,
            zIndex: 11,
            width: "100%",
            background: "#FFFFFF",
            paddingBottom: tc.safeHeigth
        }}>
            <div style={{ height: groupHeight, background: "#FFFFFF", display: "flex", justifyContent: "left", alignItems: "center", padding: "0 5px" }}>
                <Swiper
                    slidesPerView="auto"
                    style={{
                        overflow: 'hidden'
                    }}
                >
                    {
                        patternGroups.map((v: any, i: number) => (
                            <SwiperSlide
                                key={v.id}
                                style={{
                                    width: 'auto'
                                }}
                                onClick={() => loadPattern(v.id)}
                            >
                                <div style={{ padding: '0 12px', color: v.id === curPatternGroupId ? '#333333' : '#999999', display: 'inline-block', height: titleHeight, lineHeight: titleHeight + 'px', textAlign: 'center', fontWeight: 500, position: 'relative', fontSize: 14 }}>
                                    <span>{t(v.name)}</span>
                                </div>
                            </SwiperSlide>
                        ))
                    }
                </Swiper>
            </div>
            <div id="scroll" style={{
                height: tc.fabricW || 0,
                overflowY: "auto",
                overflowX: "hidden",
                padding: "0 5px",
                scrollbarWidth: 'none',
                msOverflowStyle: 'none'
            }}>
                {
                    patternList?.list && patternList?.list?.length !== 0 ? <div style={{
                        width: "calc(100vw - 13px)",
                        overflowX: "hidden"
                    }}>
                        <Infiniteloading
                            loadIcon=""
                            containerId="scroll"
                            useWindow={false}
                            hasMore={patternList?.total !== patternList?.list?.length}
                            onLoadMore={onLoadMore}
                            style={{
                                paddingBottom: 12
                            }}
                        >
                            <div style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(4,auto)"
                            }}>
                                <input onChange={fileOnChange} accept='.jpg,.jpeg,.png' type='file' ref={uploadRef} style={{ display: "none" }} />
                                <div onClick={() => {
                                    uploadRef.current.click()
                                }} style={{
                                    width: "calc((100vw - 13px)/4.4)",
                                    height: "calc((100vw - 13px)/4.4)",
                                    border: "0.3vw solid #EEEEED",
                                    overflow: "hidden",
                                    borderRadius: 8,
                                    margin: "0.8vw",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}>
                                    <img style={{
                                        width: "50%"
                                    }} src={UploadIcon} alt="" />
                                </div>
                                {
                                    patternList?.list?.map((v: any, i) => (
                                        <div key={v.id} onClick={() => previewPattern(v)} style={{
                                            width: "calc((100vw - 13px)/4.4)",
                                            height: "calc((100vw - 13px)/4.4)",
                                            border: currentPatternId === v.id ? "0.3vw solid #F57766" : "0.3vw solid #EEEEED",
                                            overflow: "hidden",
                                            borderRadius: 8,
                                            margin: "0.8vw"
                                        }}>
                                            <img style={{ width: '100%', height: '100%' }} src={v.path + "?x-oss-process=image/resize,w_100"} alt="" />
                                        </div>
                                    ))
                                }
                            </div>
                        </Infiniteloading>
                    </div> : <div style={{
                        width: "calc(100vw - 13px)",
                        overflowX: "hidden"
                    }}>
                        <Empty imageSize={Number(tc.fabricW) * 0.5 || 0} description={t('无数据')} />
                    </div>
                }

            </div>
        </Animate>

    )

}

export default Index
